var _templateObject, _templateObject2;

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  strings.raw = raw;
  return strings;
}

import { Box, Text } from "grommet";
import styled from "styled-components";
export var StyledBox = styled(Box)(
  _templateObject ||
    (_templateObject = _taggedTemplateLiteralLoose([
      "\n  min-height: 48px;\n  border-radius: 5px;\n  border: 1px solid black;\n",
    ]))
);
export var StyledText = styled(Text)(
  _templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n  line-height: 14px;\n"]))
);
